<div class="variable-picker">
  <p class="picker-title">
    <i class="fa-solid fa-brackets-curly"></i>
    Variables Disponibles
  </p>
  
  <div *ngFor="let category of categories" class="category-group">
    <h4 class="category-title">{{ categoryLabels[category] }}</h4>
    
    <div class="variables-grid">
      <div 
        *ngFor="let variable of groupedVariables[category]"
        class="variable-card"
        (click)="onVariableSelected.emit(variable.key)"
        [pTooltip]="'Ejemplo: ' + variable.example"
        tooltipPosition="top"
      >
        <div class="variable-label">{{ variable.label }}</div>
        <code class="variable-key">{{ '{{' + variable.key + '}}' }}</code>
      </div>
    </div>
  </div>
  
  <p class="picker-hint">
    <i class="fa-solid fa-circle-info"></i>
    Haz click en una variable para insertarla en el campo activo
  </p>
</div>
